<template>
    <div class="v-sidebar-menu" :class="sidebarClass" :style="[{'max-width': sidebarWidth}]" @mouseleave="onMouseLeave"
         @mouseenter="onMouseEnter">
        <slot name="header"/>
        <div class="vsm--scroll-wrapper"
            v-if="!$route.meta.noSidebarRoute"
             :style="isCollapsed && [rtl ? {'margin-left': '-17px'} : {'margin-right': '-17px'}]">
            <div class="vsm--list" :style="isCollapsed && {'width': widthCollapsed}">
                <sidebar-menu-item v-for="(item, index) in menu" :key="index" :item="item" :is-collapsed="isCollapsed"
                                   v-if="check_show_menu_item(item)"
                                   :active-show="activeShow" :show-one-child="showOneChild" :show-child="showChild"
                                   :rtl="rtl"
                                   :mobile-item="mobileItem" :disable-hover="disableHover"
                                   @set-mobile-item="setMobileItem" @unset-mobile-item="unsetMobileItem">
                    <slot slot="dropdown-icon" name="dropdown-icon"/>
                </sidebar-menu-item>
            </div>
            <div v-if="isCollapsed" class="vsm--mobile-item" :style="mobileItemStyle.item">
                <sidebar-menu-item v-if="mobileItem && check_show_menu_item(item)" :item="mobileItem" :is-mobile-item="true"
                                   :mobile-item-style="mobileItemStyle"
                                   :is-collapsed="isCollapsed" :show-child="showChild" :rtl="rtl"
                                   :disable-hover="disableHover">
                    <slot slot="dropdown-icon" name="dropdown-icon"/>
                </sidebar-menu-item>
                <transition name="slide-animation">
                    <div v-if="mobileItem" class="vsm--mobile-bg" :style="mobileItemStyle.background"/>
                </transition>
            </div>
        </div>
        <div>

        </div>
        <slot name="footer"/>
        <div class="version_no">{{ fe_version }}</div>
        <div class="version_no" v-if="be_version !== fe_version">{{ be_version }}</div>
        <div class="version_no" style="color: red; font-weight: bold;" v-if="fe_version === '?' || be_version === '?'">
            Mismatch (?)
        </div>
        <div v-else-if="be_version !== fe_version" class="version_no" style="color: red; font-weight: bold;" @click="()=>window.location.reload(true)">
            Mismatch
        </div>

        <button v-if="!hideToggle" class="vsm--toggle-btn" :class="{'vsm--toggle-btn_slot' : $slots['toggle-icon']}"
                @click="onToggleClick">
            <slot name="toggle-icon"/>
        </button>
    </div>
</template>

<script>
import SidebarMenuItem from 'components/layouts/sidebar/SidebarMenuItem.vue'

export default {
    name: 'SidebarMenu',
    components: {
        SidebarMenuItem
    },
    props: {
        menu: {type: Array, required: true},
        collapsed: {},
        width: {type: String, default: '260px'},
        widthCollapsed: {type: String, default: '40px'},
        showChild: {type: Boolean, default: false},
        theme: {type: String, default: ''},
        showOneChild: {type: Boolean, default: false},
        rtl: {type: Boolean, default: false},
        relative: {type: Boolean, default: false},
        hideToggle: {type: Boolean, default: false},
        disableHover: {type: Boolean, default: false}
    },
    data() {
        return {
            isCollapsed: this.collapsed,
            mobileItem: null,
            mobileItemPos: 0,
            mobileItemHeight: 0,
            mobileItemTimeout: null,
            activeShow: null,
            parentHeight: 0,
            parentWidth: 0,
            parentOffsetTop: 0,
            parentOffsetLeft: 0,
            fe_version: null,
            be_version: null,
            new_timesheet_permissions: [
                'menu_client_my_timesheets',
                'menu_client_submit_timesheets',
                'menu_client_timesheet_reports_header',
                'menu_client_historic_timesheets',
                'menu_client_timesheets_site_analysis',
                'menu_client_timesheets_worker_analysis',
            ],
            old_timesheet_permissions: [
                'menu_client_old_my_timesheets',
                'menu_client_old_submit_timesheets',
                'menu_client_old_historic_timesheets',
                'menu_client_old_timesheet_config',
                'menu_client_old_timesheet_setup',
                'menu_client_old_timesheet_preferences',
            ]
        }
    },
    mounted() {
        this.fe_version = window.feVersion;
        this.be_version = window.beVersion;
        this.pollVersion();
    },
    beforeDestroy() {
        clearInterval(this.versionPoller);
    },
    computed: {
        check_for_old_ts_permissions() {
            return this.$store.state.auth.me.permissions.some(r => this.old_timesheet_permissions.indexOf(r) >= 0);
        },
        sidebarWidth() {
            return this.isCollapsed ? this.widthCollapsed : this.width
        },
        sidebarClass() {
            return [
                !this.isCollapsed ? 'vsm_expanded' : 'vsm_collapsed',
                this.theme ? `vsm_${this.theme}` : '',
                this.rtl ? 'vsm_rtl' : '',
                this.relative ? 'vsm_relative' : ''
            ]
        },
        mobileItemStyle() {
            return {
                item: [
                    {'position': 'absolute'},
                    {'top': `${this.mobileItemPos}px`},
                    this.rtl ? {'right': '0px'} : {'left': '0px'},
                    this.rtl ? {'padding-right': this.sidebarWidth} : {'padding-left': this.sidebarWidth},
                    this.rtl && {'direction': 'rtl'},
                    {'z-index': 0},
                    {'width': `${this.parentWidth - this.parentOffsetLeft}px`},
                    {'max-width': this.width}
                ],
                dropdown: [
                    {'position': 'absolute'},
                    {'top': `${this.mobileItemHeight}px`},
                    {'width': '100%'},
                    {'max-height': `${this.parentHeight - (this.mobileItemPos + this.mobileItemHeight) - this.parentOffsetTop}px`},
                    {'overflow-y': 'auto'}
                ],
                background: [
                    {'position': 'absolute'},
                    {'top': '0px'},
                    {'left': '0px'},
                    {'right': '0px'},
                    {'width': '100%'},
                    {'height': `${this.mobileItemHeight}px`},
                    {'z-index': -1}
                ]
            }
        }
    },
    watch: {
        collapsed(val) {
            if (this.isCollapsed === this.collapsed) return;
            this.isCollapsed = val;
            this.mobileItem = null
        }
    },
    methods: {
        pollVersion() {
            this.versionPoller = setInterval(() => {
                if (window.feVersion !== this.fe_version) {
                    this.fe_version = window.feVersion;
                }
                if (window.beVersion !== this.be_version) {
                    this.be_version = window.beVersion;
                }
            }, 1000); // poll every second
        },
        check_show_menu_item(item) {
            let {permission, ...other} = item;

            if(this.crmCompany === 'V3 Recruitment' && item.key && item.key === 'sunset_ts_select_period'){
              //skip new timesheets on V3
              return false;
            }

            if (this.$store.state.auth.me.permissions.includes('menu_client_old_timesheet_both')) {
                return this.$store.state.auth.me.permissions.includes(permission)
            } else {
                if (this.check_for_old_ts_permissions) {
                    if (!this.new_timesheet_permissions.includes(permission)) {
                        return this.$store.state.auth.me.permissions.includes(permission)
                    }
                } else {
                    return this.$store.state.auth.me.permissions.includes(permission)
                }
            }
        },
        onMouseLeave() {
            this.unsetMobileItem(false, 300)
        },
        onMouseEnter() {
            if (this.isCollapsed) {
                if (this.mobileItemTimeout) clearTimeout(this.mobileItemTimeout)
            }
        },
        onToggleClick() {
            this.isCollapsed = !this.isCollapsed;
            this.mobileItem = null;
            this.$emit('toggle-collapse', this.isCollapsed)
        },
        onActiveShow(item) {
            this.activeShow = item
        },
        onItemClick(event, item, node) {
            this.$emit('item-click', event, item, node)
        },
        setMobileItem({item, itemEl}) {
            if (this.mobileItem === item) return;
            const sidebarTop = this.$el.getBoundingClientRect().top;
            const itemLinkEl = itemEl.children[0];
            const {top, height} = itemLinkEl.getBoundingClientRect();

            let positionTop = top - sidebarTop;
            this.initParentOffsets();
            this.mobileItem = item;
            this.mobileItemPos = positionTop;
            this.mobileItemHeight = height
        },
        unsetMobileItem(immediate, delay = 800) {
            if (!this.mobileItem) return;
            if (this.mobileItemTimeout) clearTimeout(this.mobileItemTimeout);
            if (immediate) {
                this.mobileItem = null;
                return
            }
            this.mobileItemTimeout = setTimeout(() => {
                this.mobileItem = null
            }, delay)
        },
        initParentOffsets() {
            let {top: sidebarTop, left: sidebarLeft, right: sidebarRight} = this.$el.getBoundingClientRect();
            let parent = this.relative ? this.$el.parentElement : document.documentElement;
            this.parentHeight = parent.clientHeight;
            this.parentWidth = parent.clientWidth;
            if (this.relative) {
                let {top: parentTop, left: parentLeft} = parent.getBoundingClientRect();
                this.parentOffsetTop = sidebarTop - (parentTop + parent.clientTop);
                this.parentOffsetLeft = this.rtl ? this.parentWidth - sidebarRight + (parentLeft + parent.clientLeft) : sidebarLeft - (parentLeft + parent.clientLeft)
            } else {
                this.parentOffsetTop = sidebarTop;
                this.parentOffsetLeft = this.rtl ? this.parentWidth - sidebarRight : sidebarLeft
            }
        },
        onItemUpdate(newItem, item) {
            if (item === this.mobileItem) {
                this.mobileItem = newItem
            }
            if (item === this.activeShow) {
                this.activeShow = newItem
            }
        }
    },
    provide() {
        return {
            emitActiveShow: this.onActiveShow,
            emitItemClick: this.onItemClick,
            emitItemUpdate: this.onItemUpdate
        }
    }
}
</script>

<style lang="scss">
@import '../../../sass/partials/sidebar/vue-sidebar-menu';

.version_no {
    color: lightslategrey;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
}
</style>
